import { View } from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import AwaitingCheckin from './waiting';
import InReview from './active';
import Reconnect from './reconnect';

const Checkin = () => {
  const { drawerWidth } = useAppStore();

  return (
    <View
      as="div"
      id="CheckinContainer"
      maxWidth={drawerWidth}
      minWidth={drawerWidth}
      padding="small"
    >
      <Reconnect />
      <AwaitingCheckin />
      <InReview />
    </View>
  );
};

export default Checkin;
